import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import LoadingPanel from '../../../components/LoadingPanel';
import ActionButton from '../../../components/ActionButton';
import { customer } from '../../../../modules';

const Box = ({ children, label, clickHandler, className, isLoading = false, isFailed = false, buttons }) => {
    const itemClass = classnames(className, 'boxColumn clearfix');
    return <div className={itemClass}>
        {isFailed && <div className='boxContent withPadding text-center'>
                Failed to load customer data. <a href="/">homepage</a>
            </div>
        }
        {!isLoading && <div>
            {(label || buttons) && 
                <div className='boxLabel'>
                    <span>{label}</span>
                    {clickHandler && <ActionButton action={clickHandler} className='right-button'>Detaljer</ActionButton>}
                    {buttons}
                </div>
            }
            {children &&
                <div className='boxContent clearfix'>
                    {children}
                </div>
            }
        </div>}
        {isLoading && !isFailed && <LoadingPanel />}
    </div>;
};

Box.propTypes = {
    label: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => ({
    isLoading: props.isLoading || !customer.profile.selectors.getCustomerID(state) || customer.profile.selectors.isLoading(state),
    isFailed: customer.profile.selectors.isFailed(state)
});

export default connect(mapStateToProps)(Box);
